import instance from "./index";

export const getAllProjectStatuses = async () => {
  try {
    const response = await instance.get("/projectStatus/getAll");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list
      .map((item) => {
        const value = String(item?.projectStatusName ?? item?.name ?? "").trim();
        return { value, label: value };
      })
      .filter((item) => item.value);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load project statuses";
    throw new Error(message);
  }
};
